// The app is scoped under .star3e-scope so its CSS can't leak into (or be
// overridden by) a host page when embedded - see src/index.js. Global toggle
// classes (dark mode, font size, ...) must never be applied to
// document.body/documentElement, since that would mutate the host page.
// These helpers apply them to the app's own root elements instead.
const SCOPE_IDS = ['root', 'star3e-app'];

export function addScopeClass(className) {
  SCOPE_IDS.forEach((id) => document.getElementById(id)?.classList.add(className));
}

export function removeScopeClass(className) {
  SCOPE_IDS.forEach((id) => document.getElementById(id)?.classList.remove(className));
}

export function scopeHasClass(className) {
  return document.getElementById('root')?.classList.contains(className) ?? false;
}

// Anything portaled straight to document.body (tooltips, toasts, ...) renders
// outside .star3e-scope and loses its styling once CSS is scoped. Portal into
// this instead of document.body.
export function getScopeContainer() {
  return document.getElementById('star3e-app') || document.body;
}
